import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { modules } from 'module/model/module.fragments';

import { ApiQuery } from '../../../../common/model/api.query';
import { ModuleOutput } from '../model/module.output';

export interface FetchOrganizationModulesByIdsParams {
	readonly ids: string[];
}

@Injectable({ providedIn: 'root' })
export class FetchOrganizationModulesByIdsApiQuery extends ApiQuery<
	ModuleOutput[],
	FetchOrganizationModulesByIdsParams
> {
	client = 'content';
	document = gql`
		query FetchOrganizationModulesByIds($ids: [UUID]!) {
			fetchOrganizationModulesByIds(ids: $ids) {
				...Modules
			}
		}
		${modules}
	`;
	method = 'fetchOrganizationModulesByIds';
}
